import styled from '@emotion/styled'
import { Grid, Typography } from '@mui/material'
import * as api from "api"
import { memo, useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import Shared from "theme/shared"

const errorImage = `https://via.placeholder.com/360x180/092a46/f4f7f9?text=Video_error`

const Styled = {
  Wrapper: styled.div`
    margin: 20px 0;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 60px 0;
    }
  `,
  Icons: styled.div`
    margin: 15px 0 0;
    margin-top: 15px;
    display: flex;
    justify-content: flex-start;
    overflow: auto;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 20px 15px 0;
      justify-content: center;
    }
  `,
  Icon: styled.img`
    cursor: pointer;
    display: inline-block;
    width: 84px;
    height: 62px;
    object-fit: cover;
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 112px;
    }
  `,
  Grid: styled(Grid)``,
  Title: styled(Typography)`
    font-size: 16px;
    font-weight: bold;
    padding: 5px 0;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-top: 20px;
      font-size: 18px;
    }
  `,
  Description: styled(Typography)`
    font-size: 16px;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
  `,
  Details: styled.div`
    max-width: 600px;
    padding: 0 27px;
    margin: 20px auto;
    text-align: center;
  `,
  Image: styled.img`
    margin-top: 10px;
    max-width: 100%;
  `,
  Video: styled.video`
    margin-top: 10px;
    width: 100%;
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-right: -27px;
      margin-left: -27px;
      width: calc(100% + 54px);
    }
  `,
}

type VehicleSafetySystemsProps = { data: api.SafetySystem[] }

const VehicleSafetySystems = ({ data }: VehicleSafetySystemsProps) => {
  const [selected, setSelected] = useState(data[0])
  const [error, setError] = useState(false)
  const [ref, inView] = useInView({ triggerOnce: true })

  useEffect(() => {
    setError(false)
  }, [inView])

  // data.forEach(
  //   (d) =>
  //     (d.videoUrl =
  //       "https://www.mazda.co.il/Uploads//Security_Movies/blind_spot_monitoring.mp4")
  // )
  return (
    <Styled.Wrapper ref={ref}>
      <Shared.Header>בטיחות</Shared.Header>
      <Shared.Mobile>
        <Shared.Divider />
      </Shared.Mobile>
      <Styled.Icons>
        {data.map((item, i) => (
          <Styled.Icon
            role="button"
            tabIndex={0}
            onClick={() => {
              setError(false)
              setSelected(item)
            }}
            src={item.id === selected.id ? item.iconUrl : item.iconInactiveUrl}
            key={i}
          />
        ))}
      </Styled.Icons>
      <Styled.Details>
        <Styled.Title>{selected.name}</Styled.Title>
        <Styled.Description>{selected.description}</Styled.Description>
        {!error && (
          <Styled.Video
            src={inView ? selected.videoUrl : ""}
            autoPlay
            muted
            loop
            playsInline // Fix iphone
            onError={() => setError(true)}
          />
        )}
        {error && <Styled.Image src={errorImage} />}
      </Styled.Details>
    </Styled.Wrapper>
  )
}

export default memo(VehicleSafetySystems)
